import { useContext, React, useEffect, useState } from "react";
import { HomePageContext } from "../HomePageView";
import "./homePage.css";
import CloseButton from "../../../assets/images/close.svg";
import SvgHomeWhite from "../../../assets/images/icons/SvgHomeWhite";
import SvgVilla from "../../../assets/images/icons/SvgVilla";
import SvgCustom from "../../../assets/images/icons/SvgCustom";
import ButtonComponent from "../../../components/ButtonComponent/ButtonComponent";
import Constants from "../../../constants/Contents.json";
import { motion } from "framer-motion";
import AddDevicePopup from "../../../components/AddDevicePopup/AddDevicePopup";
import { fromBottom } from "../../../utils/AnimationStyles";
import "./homePage.css";

const HomePowerPlaning = () => {
  const {
    activeTab,
    setActiveTab,
    devices,
    setDevices,
    showAddDevice,
    isDeviceSelected,
    handleToggle,
    addDevicePopupShow,
    handleAddDeviceSubmit,
    selectedIds,
    setSelectedIds,
    deviceList,
    setShowAddDevice,
    totalWatt,
    handleTabsSwitch,
    addingLimitOfDevices,
    deviceLimits
  } = useContext(HomePageContext);

  const tabs = [
    { label: "1bhk", name: "1 BHK", icon: <SvgHomeWhite /> },
    { label: "2bhk", name: "2 BHK", icon: <SvgHomeWhite /> },
    { label: "3bhk", name: "3 BHK", icon: <SvgHomeWhite /> },
    { label: "4bhk", name: "4 BHK", icon: <SvgHomeWhite /> },
    { label: "villa", name: "Villa", icon: <SvgVilla /> },
    { label: "custom", name: "Custom", icon: <SvgCustom /> },
  ];

  return (
    <div>
      <motion.div
        className="chooseTypeSection"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fromBottom}
        custom={1}
      >
        <h3>{Constants?.homePage?.chooseDataHead}</h3>
        <div className="mb-4 navWrap flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.label}
              className={`nav-link ${activeTab === tab.label && "active"}`}
              active={activeTab === tab.label}
              onClick={() => handleTabsSwitch(tab.label)}
            >
              {tab.icon}
              {tab.name}
            </button>
          ))}
        </div>
        {/* Total Watts */}
        <div className="d-flex justify-content-between align-items-center mt-3 totalWatts flex-wrap">
          <div className="deviceToggling middleHead">
            <div className="toggle-container">
              <span className={isDeviceSelected ? "active" : ""}>
                {Constants?.homePage?.selectDevice}
              </span>
              {/* <div className="toggle-switch" onClick={handleToggle}>
                <div
                  className={`toggle-circle ${
                    isDeviceSelected ? "left" : "right"
                  }`}
                />
              </div>
              <span className={!isDeviceSelected ? "active" : ""}>
                {Constants?.homePage?.selectRooms}
              </span> */}
            </div>
          </div>
          <h5 className="middleHead">
            {Constants?.homePage?.totalWatt}
            <span>
              {totalWatt}
              {Constants?.homePage?.wattsValue}
            </span>
          </h5>
          <ButtonComponent
            buttonText={Constants?.homePage?.addDevice}
            onClick={addDevicePopupShow}
            className={"addDeviceBtn middleHead"}
          />
        </div>
        <div className="tableCard table-container">
        <table className="table">
      <thead>
        <tr>
          <th className="leftAlign">Device</th>
          <th>Usage</th>
          <th>Count</th>
          <th>Total</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {devices.length > 0 ? (
          devices.map((device, index) => {
            const deviceLimit = deviceLimits[device.deviceId] ?? null; // Get limit for this device

            return (
              <tr key={index}>
                <td className="leftAlign">{device.deviceName}</td>
                <td>
                  {device.deviceUsage}{Constants?.homePage?.wattsValue}
                </td>
                <td>
                  <div className="quantitySection">
                    {/* Decrement Button */}
                    <button
                      onClick={() => {
                        if (device.quantity > 1) {
                          const newDevices = [...devices];
                          newDevices[index].quantity -= 1;
                          setDevices(newDevices);
                        }
                      }}
                      disabled={device.quantity === 1}
                      className="qualityBtns"
                      style={{
                        opacity: device.quantity === 1 ? 0.5 : 1,
                        cursor: device.quantity === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      -
                    </button>

                    {/* Quantity Display */}
                    <span className="quantity">
                      <input
                        type="text"
                        className="deviceQty"
                        value={device.quantity}
                        onChange={(e) => {
                          const newDevices = [...devices];
                          let newQty = Math.max(Number(e.target.value) || 0, 1);
                          if (deviceLimit !== null) {
                            newQty = Math.min(newQty, deviceLimit); // Apply limit if exists
                          }
                          newDevices[index].quantity = newQty;
                          setDevices(newDevices);
                        }}
                      />
                    </span>

                    {/* Increment Button */}
                    <button
                      onClick={() => {
                        const newDevices = [...devices];
                        if (deviceLimit === null || device.quantity < deviceLimit) {
                          newDevices[index].quantity += 1;
                          setDevices(newDevices);
                        }
                      }}
                      disabled={deviceLimit !== null && device.quantity >= deviceLimit}
                      className="qualityBtns"
                      style={{
                        opacity: deviceLimit !== null && device.quantity >= deviceLimit ? 0.5 : 1,
                        cursor:
                          deviceLimit !== null && device.quantity >= deviceLimit
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      +
                    </button>
                  </div>
                </td>

                <td>{device.deviceUsage * device.quantity}W</td>
                <td>
                  <button
                    className="cancelBtns"
                    onClick={() => {
                      setDevices(devices.filter((_, i) => i !== index));
                    }}
                  >
                    <img src={CloseButton} alt="close" />
                  </button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="5" className="text-center">
              {Constants.homePage.noDevice}
            </td>
          </tr>
        )}
      </tbody>
    </table>
        </div>
      </motion.div>
      <AddDevicePopup
        show={showAddDevice}
        data={deviceList}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        addDeviceSubmit={handleAddDeviceSubmit}
        handleClose={() => setShowAddDevice(false)}
      />
    </div>
  );
};
export default HomePowerPlaning;
